import Component from "../abstracts/Component";

export default class CarouselComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-carousel="true"]:not(.slick-initialized)',
      prevArrow: '[data-prev-arrow]',
      nextArrow: '[data-next-arrow]',
    };
  }

  constructor() {
    super();
    this.main = $(this.SELECTORS.main);
    this.whatchRes = [];
  }

  importLibrary(elem) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initCarousels(elem);
        this.manageMobileCarousels();
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  initCarousels(elem) {
    let selector = this.SELECTORS.main;
    let carousels = [];
    if (
      elem != null &&
      typeof elem != "undefined" &&
      document.getElementsByClassName(elem).length
    )
      carousels = document.getElementsByClassName(elem);
    else carousels = document.querySelectorAll(selector);

    for (let carousel of carousels) {
      // data-mobile-max-width was originally intended for mobile (e.g., up to 767px)
      // In specific contexts, it can be overridden (e.g., 1279) to include tablets
      const maxMobileWidth = parseInt(carousel.dataset.mobileMaxWidth, 10) || 767;
      const isMobile = window.innerWidth <= maxMobileWidth;
      // Number of slides configured via data attribute, default to 1
      const slides =
        typeof carousel.dataset.slides != "undefined"
          ? Number(carousel.dataset.slides)
          : 1;
      const visibleItemsMobile =
        this.checkMobileCarousel(carousel);
      const visibleItemsTablet =
        typeof carousel.dataset.visibleItemsMd != "undefined"
          ? Number(carousel.dataset.visibleItemsMd)
          : slides;
      const visibleItemsDesktop =
        typeof carousel.dataset.visibleItemsLg != "undefined"
          ? Number(carousel.dataset.visibleItemsLg)
          : slides;
      // Uses data-dots as fallback; overrides with mobile/desktop values if set
      const dots = carousel.dataset.dots !== undefined ? carousel.dataset.dots === "true" : false;
      const dotsMobile = carousel.dataset.dotsMobile !== undefined ? carousel.dataset.dotsMobile === "true" : dots;
      const dotsDesktop = carousel.dataset.dotsDesktop !== undefined ? carousel.dataset.dotsDesktop === "true" : dots;
      // Enables fade effect if data-fade="true"
      const isFade = carousel.dataset.fade === "true" ? true : false;
      // Enables center mode if data-centerslick="true"
      const isCenter = carousel.dataset.centerslick === "true" ? true : false;
      // Uses data-arrows as fallback; overrides with mobile/desktop values if set
      const arrows = carousel.dataset.arrows !== undefined ? carousel.dataset.arrows === "true" : false;
      const arrowsMobile = carousel.dataset.arrowsMobile !== undefined ? carousel.dataset.arrowsMobile === "true" : arrows;
      const arrowsDesktop = carousel.dataset.arrowsDesktop !== undefined ? carousel.dataset.arrowsDesktop === "true" : arrows;
      //
      const prevArrow =
        carousel.dataset.customarrows === "true"
          ? '<span class="fade-prev__outer"></span><button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">Previous</button><span class="fade-prev_inner"></span>'
          : '<span class="fade-prev__outer"></span><button type="button" class="w__slick-prev icon-slick-prev" aria-label="previous slide" data-prev-arrow><i class="icon-slick-prev"></i></button><span class="fade-prev__inner"></span>';
      const nextArrow =
        carousel.dataset.customarrows === "true"
          ? '<span class="fade-next__inner"></span><button class="slick-next slick-arrow" aria-label="Next" type="button" style="">Next</button><span class="fade-next__outer"></span>'
          : '<span class="fade-next__inner"></span><button type="button" class="w__slick-next icon-slick-next" aria-label="next slide" data-next-arrow><i class="icon-slick-next"></i></button><span class="fade-next__outer"></span>';
      const isAccessible =
        carousel.dataset.accessibility === "true" ? true : false;
      const isAutoplay = carousel.dataset.autoplay === "true" ? true : false;
      const isDraggable = carousel.dataset.draggable === "false" ? false : true;
      const isInfinite = carousel.dataset.infinite === "true" ? true : false;
      const autoplaySpeed =
        typeof carousel.dataset.autoplaySpeed != "undefined"
          ? carousel.dataset.autoplaySpeed
          : 3000;
      const slidesToScroll =
        typeof carousel.dataset.slidesToScroll != "undefined"
          ? Number(carousel.dataset.slidesToScroll)
          : 1;
      const slidesToScrollMobile =
        typeof carousel.dataset.slidesToScrollMobile != "undefined"
          ? Number(carousel.dataset.slidesToScrollMobile)
          : 1;
      const isVariableWidth =
        carousel.dataset.variablewidth === "true" ? true : false;
      const centerPadding =
        carousel.dataset.centerpadding != undefined ? carousel.dataset.centerpadding : "";
      const customPaging = function(slider, i) {
        const totalSlides = slider.slideCount;
        const slidesToShow = slider.options.slidesToShow;
        const totalPages = Math.ceil(totalSlides / slidesToShow);
        
        // Get pagination template from carousel data attribute
        const paginationTemplate = carousel.dataset.dotsPaginationLabel;
        const ariaLabel = paginationTemplate.replace('{0}', i + 1).replace('{1}', totalPages);
        return $(`<button role="tab" aria-label="${ariaLabel}"><i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i></button>`);
      };

      let options = {
        dots: isMobile ? dotsMobile : dotsDesktop,
        arrows: isMobile ? arrowsMobile : arrowsDesktop,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        infinite: isInfinite,
        centerMode: isCenter,
        centerPadding: centerPadding,
        autoplay: isAutoplay,
        autoplaySpeed: autoplaySpeed,
        accessibility: isAccessible,
        draggable: isDraggable,
        slidesToShow: slides,
        slidesToScroll: slidesToScroll,
        slidesToScrollMobile: slidesToScrollMobile,
        fade: isFade,
        variableWidth: isVariableWidth,
        customPaging: customPaging
      };

      let responsiveArray = this.setResponsiveArray(
        visibleItemsMobile,
        visibleItemsTablet,
        visibleItemsDesktop,
        slidesToScrollMobile
      );

      options = $.extend({}, options, {
        responsive: responsiveArray
      });

      const editMode = carousel.dataset.editMode === "true" ? true : false;
      if (editMode) return false;

      const onlyMobile = carousel.dataset.onlyMobile === "true" ? true : false;
      // Retrieves values from the dataset, parses them to integers, and assigns default values if not provided
      const carouselCount = parseInt(carousel.dataset.carouselCount, 10) || 0;
      const minDesktopItems = parseInt(carousel.dataset.minDesktopItems, 10) || 5;
      // Allows flexible desktop breakpoints (e.g., 992px or 1280px) via dataset
      const desktopMinWidth = carousel.dataset.desktopMinWidth;
      const hasDesktopMinWidth = desktopMinWidth !== undefined;
      const isDesktopBreakpoint = hasDesktopMinWidth && window.innerWidth >= parseInt(desktopMinWidth, 10);

      let checkItems = slides;
      if (window.matchMedia("(max-width:767px)").matches || onlyMobile)
        checkItems = visibleItemsMobile;
      else if (window.matchMedia("(max-width:1280px)").matches)
        checkItems = visibleItemsTablet;
      $(carousel).on('init', () => {
        this.animateArrows(carousel);
        this.updateArrowsAccessibility(carousel);
        this.setupKeyboardNavigationForVisibleSlides(carousel);
        // Apply keyboard navigation priority only for specific components who want first to navigate to arrows
        if (carousel.dataset.keyboardNavPriority === "true") {
          this.setupKeyboardNavigation(carousel);
        }
        this.$emit(this.$customEvents.CAROUSEL.initCarousel,{carousel: carousel});
      });
      
      // Listen for slide changes to update arrow accessibility
      $(carousel).on('afterChange', () => {
        this.updateArrowsAccessibility(carousel);
        this.setupKeyboardNavigationForVisibleSlides(carousel);
        // Apply keyboard navigation priority only for specific components
        if (carousel.dataset.keyboardNavPriority === "true") {
          this.setupKeyboardNavigation(carousel);
        }
      });
      if (
        carousel.children.length < checkItems ||
        !$(carousel).is(":visible")
      ) {
        this.log("Carousel not triggered");
        carousel.classList.add('no_carousel');
      } else if (window.matchMedia("(max-width:767px)").matches && onlyMobile) {
        $(carousel).slick(options);
        this.log("Carousel Triggered");
      } else if (isDesktopBreakpoint && carouselCount >= minDesktopItems) {
        // If the desktop breakpoint is reached and the number of items is sufficient, activate the carousel
        $(carousel).slick(options);
        this.log("Carousel Triggered");
      } else if (!onlyMobile && !isDesktopBreakpoint) {
        $(carousel).slick(options);
        this.log("Carousel Triggered");
      }
    }
  }

  setResponsiveArray(
    visibleItemsMobile,
    visibleItemsTablet,
    visibleItemsDesktop,
    slidesToScrollMobile
  ) {
    let responsiveArray = [];
    if (visibleItemsMobile == "unslick") {
      responsiveArray.push({
        breakpoint: 768,
        settings: visibleItemsMobile
      });
    } else {
      responsiveArray.push({
        breakpoint: 768,
        settings: {
          slidesToShow: visibleItemsMobile,
          slidesToScroll: slidesToScrollMobile
        }
      });
    }
    if (visibleItemsTablet == "unslick") {
      responsiveArray.push({
        breakpoint: 1280,
        settings: visibleItemsTablet
      });
    } else {
      responsiveArray.push({
        breakpoint: 1280,
        settings: {
          slidesToShow: visibleItemsTablet
        }
      });
    }
    //set only if not a carousel in desktop else use default configs
    if (visibleItemsDesktop == "unslick") {
      responsiveArray.push({
        breakpoint: 60000,
        settings: visibleItemsDesktop
      });
    }
    return responsiveArray;
  }

  animateArrows(carousel) {
    let prevArrow = carousel.querySelector(this.SELECTORS.prevArrow);
    if (prevArrow) {
      prevArrow.addEventListener('mousedown', () => {
        prevArrow.classList.remove('transition');
      });
      prevArrow.addEventListener('click', () => {
        prevArrow.classList.add('transition');
      });
    }
    let nextArrow = carousel.querySelector(this.SELECTORS.nextArrow);
    if (nextArrow) {
      nextArrow.addEventListener('mousedown', () => {
        nextArrow.classList.remove('transition');
      });
      nextArrow.addEventListener('click', () => {
        nextArrow.classList.add('transition');
      });
    }
  }

  updateArrowsAccessibility(carousel) {
    let prevArrow = carousel.querySelector(this.SELECTORS.prevArrow);
    let nextArrow = carousel.querySelector(this.SELECTORS.nextArrow);
    
    if (prevArrow) {
      if (prevArrow.classList.contains('slick-disabled')) {
        // set focus for safari keyboard navigation
        if (document.activeElement === prevArrow) {
          this.focusFirstVisibleSlide(carousel);
        }
        prevArrow.setAttribute('disabled', 'true');
        prevArrow.setAttribute('tabindex', '-1');
      } else {
        prevArrow.removeAttribute('disabled');
        prevArrow.removeAttribute('tabindex');
      }
    }
    if (nextArrow) {
      if (nextArrow.classList.contains('slick-disabled')) {
        // set focus for safari keyboard navigation
        if (document.activeElement === nextArrow) {
          this.focusFirstVisibleSlide(carousel);
        }
        nextArrow.setAttribute('disabled', 'true');
        nextArrow.setAttribute('tabindex', '-1');
      } else {
        nextArrow.removeAttribute('disabled');
        nextArrow.removeAttribute('tabindex');
      }
    }
  }

  focusFirstVisibleSlide(carousel) {
    const firstVisibleSlide = carousel.querySelector('.slick-active');
    if (firstVisibleSlide) {
      const focusableElement = firstVisibleSlide.querySelector(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusableElement) {
        focusableElement.focus();
      }
    }
  }

  setupKeyboardNavigation(carousel) {
    // Simply reorder DOM elements to put next arrow after prev arrow
    const prevArrow = carousel.querySelector(this.SELECTORS.prevArrow);
    const nextArrow = carousel.querySelector(this.SELECTORS.nextArrow);
    const slickList = carousel.querySelector('.slick-list');
    
    if (prevArrow && nextArrow && slickList) {
      // Check if we need to preserve focus on next arrow
      const shouldRestoreFocus = document.activeElement === nextArrow;
      
      // Move next arrow to be right after prev arrow in DOM
      prevArrow.parentNode.insertBefore(nextArrow, prevArrow.nextSibling);
      
      // Restore focus if it was on the next arrow
      if (shouldRestoreFocus) {
        nextArrow.focus();
      }
    }
  }

  //accessibility: setup keyboard navigation only for visible slides

  setupKeyboardNavigationForVisibleSlides(carousel) {
    const slides = carousel.querySelectorAll('.slick-slide:not(.slick-cloned)');
    const slickTrack = carousel.querySelector('.slick-track');
    
    if (!slides.length || !slickTrack) return;

    slides.forEach((slide, index) => {
      // Find all focusable elements within each slide
      const focusableElements = slide.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );

      focusableElements.forEach(element => {
        // Check if the slide is currently visible
        if (slide.classList.contains('slick-active')) {
          // Make focusable elements in visible slides accessible
          element.removeAttribute('tabindex');
          element.setAttribute('aria-hidden', 'false');
        } else {
          // Make focusable elements in hidden slides inaccessible
          element.setAttribute('tabindex', '-1');
          element.setAttribute('aria-hidden', 'true');
        }
      });

      // Also set aria-hidden on the slide itself
      if (slide.classList.contains('slick-active')) {
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }

  checkMobileCarousel(carousel) {
    if (carousel.classList.contains('not-mobile')) {
      return 'unslick';
    } else {
      if (typeof carousel.dataset.visibleItemsXs !== "undefined") {
        return Number(carousel.dataset.visibleItemsXs);
      } else { return carousel.dataset.slides;}
    }
  }

  bindEvents() {
    this.$on(this.$customEvents.MODAL_EVENTS.afterOpen, () => {
      console.log("afterOpen Modal");
      let carouselsIntoVex = document
        .querySelector(".vex")
        .querySelectorAll('[data-carousel="in-vex"]');
      if (carouselsIntoVex.length > 0) {
        for (let carouselInVex of carouselsIntoVex) {
          carouselInVex.dataset.carousel = "true";
        }
        this.initCarousels();
      }
    });

    this.$on(this.$customEvents.CAROUSEL.triggerCarousel, data => {
      this.importLibrary(data.payload);
    });

    // Handle window resize to update arrow accessibility
    window.addEventListener('resize', () => {
      const carousels = document.querySelectorAll('.slick-slider');
      carousels.forEach(carousel => {
        this.updateArrowsAccessibility(carousel);
      });
    });
  }

  manageMobileCarousels() {
    let carousels = document.querySelectorAll('.slick-slider');
    for (let carousel of carousels) {
      let slickDots = $(carousel).find('.slick-dots');
      if (slickDots.length) {
        if ($(slickDots).children('li').length > 6 && $(slickDots).parent('.slick-dots-container').length == 0) {
          $(slickDots).wrap("<div class='slick-dots-container'></div>");
          $(slickDots).find('li').each(function (index) {
            $(this).addClass('dot-index-' + index);
          });
          if (slickDots.children('li').length > 14) {
            $(slickDots).css('transform', 'translateX(80px)');
          } else {
            $(slickDots).css('transform', 'translateX(40px)');
          }
          $(carousel).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            let currentTranslateX = parseInt($(this).find('.slick-dots').css('transform').split(',')[4]);
            let transformCount = 0;
            if (!$(this).find('ul.slick-dots li:first-child').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:nth-child(2)').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:last-child').hasClass('slick-active') &&
              !$(this).find('ul.slick-dots li:nth-last-child(2)').hasClass('slick-active')) {
              if (nextSlide > currentSlide) {
                if(!$(this).find('ul.slick-dots li:nth-last-child(3)').hasClass('slick-active')) {
                  transformCount = currentTranslateX - 40;
                  $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                }
              } else {
                if(!$(this).find('ul.slick-dots li:nth-child(3)').hasClass('slick-active') ) {
                  transformCount = currentTranslateX + 40;
                  $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
                }
              }
            }
          });
        }
      }
    }
  }

  render() {
    super.render();
    if (document.querySelectorAll("[data-carousel]").length) {
      this.importLibrary();
    }
    this.bindEvents();
  }
}
